import React from 'react';
import { useRoundingTFunction } from '@retail/rounding/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, MenuItem, Select } from '@mui/material';
import { ErrorTooltip } from '@retail/components';
import { PriceRoundingRuleConfigSchema } from './roundingRuleSchema';

interface Props {
  index: number;
}

export const RoundingModeInput = ({ index }: Props) => {
  const t = useRoundingTFunction();
  const { control } = useFormContext<PriceRoundingRuleConfigSchema>();

  const roundingModeMenuItems = [
    {
      name: t('rounding.keep'),
      value: 'KEEP',
    },
    {
      name: t('rounding.closest'),
      value: 'CLOSEST',
    },
    {
      name: t('rounding.upTo'),
      value: 'ROUND_UP',
    },
  ];

  return (
    <Controller
      name={`rules.${index}.roundingMode`}
      control={control}
      render={({ field, fieldState }) => (
        <ErrorTooltip title={fieldState.error?.message} arrow placement="top">
          <Select
            size="small"
            {...field}
            value={field.value ?? ''}
            error={!!fieldState.error}
            sx={{ width: 150, my: 1 }}
            displayEmpty
            renderValue={(value) => {
              if (!value) {
                return (
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {t('rounding.choose')}
                  </Box>
                );
              }
              const selectedItem = roundingModeMenuItems.find((item) => item.value === value);
              return selectedItem?.name;
            }}
          >
            {roundingModeMenuItems.map(({ name, value }) => (
              <MenuItem key={value} value={value}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </ErrorTooltip>
      )}
    />
  );
};
